
import { Auth, ProgressBar } from '@spendlevel/shared-login-frontend';
import { useEffect, useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

// If the user is already authenticated, redirect to secure resource
/*Auth.isAuthenticated('admin').then(value => {
    if (value) {
        window.location.href = '/secure';
    }
});*/

function Login() {
    const [errorMsgHidden, setErrorMsgHidden] = useState('none');
    const [showProgressBar, setShowProgressBar] = useState(false);
    let navigate = useNavigate();

    // Handle submit of login button
    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();

        setErrorMsgHidden('none');
        setShowProgressBar(true);
        
        const result = await Auth.signIn('admin', {
        email: (document.getElementById('emailAddress') as HTMLInputElement).value,
        password: (document.getElementById('password') as HTMLInputElement).value,
        });

        setShowProgressBar(false);

        switch (result?.status) {
            case 'Failed':
                setErrorMsgHidden('contents');
                break;
            case 'MFA':
                navigate('/mfa', {state: {isMfa: true}});
                break;
            case 'MFASetup':
                navigate('/mfasetup', {state: {mfaSetupUrl: result.mfaSetupUrl}});
                break;
            case 'UpdatePassword':
                navigate('/updatepassword', {state: {email: (document.getElementById('emailAddress') as HTMLInputElement).value}});
                break;
        }
    };

    // Handle focus of email address and password
    const handleFocus = () => {
        setErrorMsgHidden('none');
    }

    useEffect(() => {
        
        // If the user is already authenticated, redirect to secure resource
        (async () => {
            if (await Auth.isAuthenticated('admin')) {
                //window.location.href = '/secure';
                navigate('/iframe');
            }
        })();
        

        document?.querySelector('html')?.setAttribute('data-bs-theme', 'dark');
        if (localStorage) {
        localStorage.appDarkMode = true;
        }
        document.dispatchEvent(new Event('theme-reload'));
        }, [navigate]);

    return (
        <>
        <div className="login login-v2 fw-bold">
            <div className="login-cover">
                <div className="login-cover-img" style={{ backgroundImage: `url(/assets/login-bg-17.jpg)` }}></div>
                <div className="login-cover-bg">{showProgressBar && <ProgressBar/>}</div>
            </div>
            <div className="login-container">
                <div className="login-header">
                    <div className="brand">
                    <div className="d-flex align-items-center">
                        <span className="logo"></span> <b>SpendLevel</b> Admin
                    </div>
                    <small>System Administration Portal</small>
                    </div>
                    <div className="icon">
                    <i className="fa fa-lock"></i>
                    </div>
                </div>

                <div className="login-content">
                    <form onSubmit={handleSubmit}>
                    <div className="form-floating mb-20px">
                        <input type="text" className="form-control fs-13px h-45px border-0" placeholder="Email Address" id="emailAddress" onFocus={handleFocus} />
                        <label htmlFor="emailAddress" className="d-flex align-items-center text-gray-600 fs-13px">Email Address</label>
                    </div>
                    <div className="form-floating mb-20px">
                        <input type="password" className="form-control fs-13px h-45px border-0" placeholder="Password" id="password" onFocus={handleFocus} />
                        <label htmlFor="emailAddress" className="d-flex align-items-center text-gray-600 fs-13px">Password</label>
                    </div>
                    <div>
                        <span style={{textAlign: 'center', display: errorMsgHidden}}>
                        <div className="alert alert-danger" style={{border: '1px solid #ff9d9a', fontWeight: '400 !important'}}>Authorization failed.  Please verify your credentials.</div>
                        </span>
                    </div>
                    <div className="mb-20px">
                        <button type="submit" className="btn btn-theme d-block w-100 h-45px btn-lg">Sign me in</button>
                    </div>
                    <div className="text-gray-500">
                        This site is protected with MFA using Google Authenticator.
                    </div>
                    </form>
                </div>
            </div>
        </div>
        </>
    );
}

export default Login;